import { motion } from "framer-motion";
import logo from '../assets/Logo.png'

export default function Footer() {
  return (
    <motion.footer
      className="bg-gray-900 text-gray-400"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <div className="max-w-5xl mx-auto px-4 py-8 text-center">
        <img src={logo} alt="Logo" className="mx-auto w-32 mb-2" />
        <p className="text-sm">
          Empowering innovators and connecting possibilities since 2025.
        </p>

        <div className="flex justify-center gap-4 mt-4">
          {["in", "IG", "X", "FB"].map((item) => (
            <a
              href="#"
              key={item}
              className="hover:text-white transition-colors duration-300"
            >
              {item}
            </a>
          ))}
        </div>
      </div>

      <div className="border-t border-gray-700 mt-4 py-4 text-xs px-4 max-w-5xl mx-auto flex flex-col md:flex-row justify-between gap-2 text-center md:text-left">
        <p>© 2025 Startup Platform. All rights reserved.</p>
        <p>
          Designed by{" "}
          <a
            href="https://hfadigitalcreations.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold hover:text-white transition-colors duration-300"
          >
            HFA Digital Creations
          </a>
        </p>
        <div className="space-x-3">
          <a
            href="#"
            className="hover:text-white transition-colors duration-300"
          >
            Privacy
          </a>
          <a
            href="#"
            className="hover:text-white transition-colors duration-300"
          >
            Terms
          </a>
          <a
            href="#"
            className="hover:text-white transition-colors duration-300"
          >
            Cookies
          </a>
        </div>
      </div>
    </motion.footer>
  );
}
